/* Muksun Arcade theme scripts — small, dependency-free */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  const addDays = (n) => { const d = new Date(); d.setHours(12, 0, 0, 0); d.setDate(d.getDate() + Number(n)); return d; };
  const fmtDate = (d) => d.toLocaleDateString(document.documentElement.lang || 'en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  const money = (cents, format) => {
    const fmt = format || '${{amount}}';
    const v = (cents / 100);
    const withCommas = (n, dec, t = ',', d = '.') => { const [a, b] = n.toFixed(dec).split('.'); return a.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (b ? d + b : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: withCommas(v, 2), amount_no_decimals: withCommas(v, 0),
      amount_with_comma_separator: withCommas(v, 2, '.', ','), amount_no_decimals_with_comma_separator: withCommas(v, 0, '.', ','),
    }[k] ?? withCommas(v, 2)));
  };

  /* live delivery dates: <span data-eta-days="7"></span> */
  function paintEta(root = document) { $$('[data-eta-days]', root).forEach((el) => { el.textContent = fmtDate(addDays(el.dataset.etaDays)); }); }
  paintEta();

  /* mobile menu */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-menu-toggle]');
    if (!t) return;
    const nav = document.getElementById(t.getAttribute('aria-controls'));
    const open = t.getAttribute('aria-expanded') !== 'true';
    t.setAttribute('aria-expanded', String(open));
    nav?.classList.toggle('is-open', open);
  });

  /* hero screenshot switcher */
  class ScreenSwitcher extends HTMLElement {
    connectedCallback() {
      this.slides = $$('.screen__slide', this);
      this.dots = $$('[data-slide]', this);
      this.caption = $('[data-caption]', this);
      this.play = $('[data-play-link]', this);
      this.dots.forEach((b) => b.addEventListener('click', () => this.go(Number(b.dataset.slide))));
    }
    go(i) {
      this.slides.forEach((s, j) => s.classList.toggle('is-active', i === j));
      this.dots.forEach((d, j) => d.setAttribute('aria-pressed', String(i === j)));
      const s = this.slides[i];
      if (this.caption) this.caption.textContent = s.dataset.caption || '';
      if (this.play && s.dataset.link) this.play.href = s.dataset.link;
    }
  }
  customElements.define('screen-switcher', ScreenSwitcher);

  /* before / after slider */
  class CompareSlider extends HTMLElement {
    connectedCallback() {
      this.frame = $('.compare__frame', this);
      this.range = $('input[type=range]', this);
      const set = (v) => { this.frame.style.setProperty('--x', `${v}%`); if (this.range) this.range.value = v; };
      this.range?.addEventListener('input', () => set(this.range.value));
      this.frame.addEventListener('pointerdown', (e) => {
        const move = (ev) => { const r = this.frame.getBoundingClientRect(); set(Math.round(Math.max(0, Math.min(100, ((ev.clientX - r.left) / r.width) * 100)))); };
        move(e);
        try { this.frame.setPointerCapture(e.pointerId); } catch (_) { /* ignore */ }
        const up = () => { this.frame.removeEventListener('pointermove', move); this.frame.removeEventListener('pointerup', up); };
        this.frame.addEventListener('pointermove', move);
        this.frame.addEventListener('pointerup', up);
      });
    }
  }
  customElements.define('compare-slider', CompareSlider);

  /* reviews carousel */
  class ReviewCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = $$('.review-slide', this);
      this.count = $('[data-count]', this);
      this.i = 0;
      $$('[data-step]', this).forEach((b) => b.addEventListener('click', () => this.go(this.i + Number(b.dataset.step))));
    }
    go(i) {
      if (!this.slides.length) return;
      this.i = (i + this.slides.length) % this.slides.length;
      this.slides.forEach((s, j) => s.classList.toggle('is-active', j === this.i));
      if (this.count) this.count.textContent = `${this.i + 1} / ${this.slides.length}`;
    }
  }
  customElements.define('review-carousel', ReviewCarousel);

  /* trailer player: swaps the poster for the video / embed */
  class GamePlayer extends HTMLElement {
    connectedCallback() {
      this.tpl = $('template', this);
      $$('[data-play]', this.closest('section') || document).forEach((b) => b.addEventListener('click', () => this.play()));
      if (new URLSearchParams(location.search).get('play') === '1') this.play();
    }
    play() {
      if (this.classList.contains('is-playing') || !this.tpl) return;
      this.classList.add('is-playing');
      this.appendChild(this.tpl.content.cloneNode(true));
      const v = $('video', this); if (v) v.play().catch(() => {});
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  customElements.define('game-player', GamePlayer);

  /* gift certificate live preview */
  class CertificateBuilder extends HTMLElement {
    connectedCallback() {
      $$('[data-bind]', this).forEach((input) => {
        const update = () => {
          $$(`[data-out="${input.dataset.bind}"]`, this).forEach((o) => {
            if (input.type === 'date') o.textContent = input.value ? fmtDate(new Date(`${input.value}T12:00:00`)) : o.dataset.empty;
            else o.textContent = input.value || o.dataset.empty;
          });
        };
        input.addEventListener('input', update);
        update();
      });
      $('[data-print]', this)?.addEventListener('click', () => window.print());
    }
  }
  customElements.define('certificate-builder', CertificateBuilder);

  /* product form: editions, hero count, rush, live price + delivery date */
  class ProductBuilder extends HTMLElement {
    connectedCallback() {
      this.product = JSON.parse($('[data-product-json]', this).textContent);
      this.cfg = JSON.parse($('[data-config-json]', this).textContent);
      this.form = $('form.product-form', this);
      this.idInput = $('input[name="id"]', this.form);
      this.inputs = $$('[data-option-index]', this);
      this.rush = $('[data-rush-toggle]', this);
      this.inputs.forEach((i) => i.addEventListener('change', () => this.update()));
      this.rush?.addEventListener('change', () => this.update());
      $('[data-big-day]', this)?.addEventListener('change', () => this.update());
      $('[data-add-rush]', this)?.addEventListener('click', () => { if (this.rush) { this.rush.checked = true; this.update(); } });
      $('[data-theme-select]', this)?.addEventListener('change', () => this.update());
      $$('[data-theme-radio]', this).forEach((r) => r.addEventListener('change', () => this.update()));
      this.update();
    }
    selected() {
      const opts = this.product.options.map((_, i) => {
        const checked = this.inputs.find((el) => Number(el.dataset.optionIndex) === i && (el.type === 'radio' ? el.checked : true));
        return checked ? checked.value : null;
      });
      if (this.rush && this.cfg.deliveryIndex > -1) opts[this.cfg.deliveryIndex] = this.rush.checked ? this.cfg.rushValue : this.cfg.standardValue;
      return opts;
    }
    findVariant(opts) { return this.product.variants.find((v) => v.options.every((o, i) => opts[i] == null || o === opts[i])); }
    // grey out option values that don't exist with the other current choices (e.g. 6 heroes on Classic)
    refreshAvailability() {
      const opts = this.selected();
      this.inputs.filter((el) => el.type === 'radio').forEach((el) => {
        const i = Number(el.dataset.optionIndex);
        const primary = this.cfg.editionIndex > -1 ? this.cfg.editionIndex : 0;
        if (i === primary) return; // the edition choice always stays clickable
        const test = opts.slice(); test[i] = el.value;
        const exists = this.product.variants.some((v) => v.options.every((o, j) => o === test[j]));
        el.disabled = !exists;
        el.closest('label')?.classList.toggle('is-unavailable', !exists);
      });
      if (!this.findVariant(opts)) {
        // current combo is impossible: pick the closest existing value for each other option, last option first
        const primary = this.cfg.editionIndex > -1 ? this.cfg.editionIndex : 0;
        for (let i = this.product.options.length - 1; i >= 0; i--) {
          if (i === primary) continue;
          const group = this.inputs.filter((el) => el.type === 'radio' && Number(el.dataset.optionIndex) === i);
          const ok = group.filter((el) => !el.disabled);
          if (ok.length && !ok.some((el) => el.checked)) { ok[ok.length - 1].checked = true; return this.refreshAvailability(); }
        }
      }
    }
    update() {
      this.refreshAvailability();
      const opts = this.selected();
      const variant = this.findVariant(opts);
      const fmt = this.cfg.moneyFormat;
      const btns = $$('[data-add-button]', this);
      const unavailable = !variant || !variant.available;
      btns.forEach((b) => { b.disabled = unavailable; });
      $$('[data-button-label]', this).forEach((l) => { l.textContent = !variant ? this.cfg.t.unavailable : !variant.available ? this.cfg.t.soldOut : `${this.cfg.t.add} — ${money(variant.price, fmt)}`; });
      if (!variant) return;
      this.idInput.value = variant.id;
      $$('[data-price]', this).forEach((el) => { el.textContent = money(variant.price, fmt); });

      // price lines: edition base vs rush difference
      let rushDiff = 0;
      if (this.cfg.deliveryIndex > -1) {
        const std = opts.slice(); std[this.cfg.deliveryIndex] = this.cfg.standardValue;
        const rsh = opts.slice(); rsh[this.cfg.deliveryIndex] = this.cfg.rushValue;
        const sv = this.findVariant(std), rv = this.findVariant(rsh);
        if (sv && rv) {
          rushDiff = rv.price - sv.price;
          $$('[data-rush-price]', this).forEach((el) => { el.textContent = `+${money(rushDiff, fmt)}`; });
          $$('[data-base-price]', this).forEach((el) => { el.textContent = money(sv.price, fmt); });
        }
      } else {
        $$('[data-base-price]', this).forEach((el) => { el.textContent = money(variant.price, fmt); });
      }
      const isRush = Boolean(this.rush?.checked);
      $$('[data-rush-line]', this).forEach((el) => { el.hidden = !isRush; });
      if (this.cfg.editionIndex > -1) $$('[data-edition-line]', this).forEach((el) => { el.textContent = opts[this.cfg.editionIndex] || ''; });

      // hero slots
      if (this.cfg.heroesIndex > -1) {
        const n = parseInt(opts[this.cfg.heroesIndex], 10) || 1;
        $$('.slot', this).forEach((s, i) => s.classList.toggle('is-on', i < n));
        $$('[data-heroes-line]', this).forEach((el) => { el.textContent = opts[this.cfg.heroesIndex]; });
      }

      // world picker: only applies to the pre-made-world edition
      const themeBox = $('[data-theme-block]', this);
      if (themeBox) {
        const want = (themeBox.dataset.showFor || '').trim().toLowerCase();
        const edition = this.cfg.editionIndex > -1 ? String(opts[this.cfg.editionIndex] || '').toLowerCase() : '';
        const on = !want || edition.includes(want);
        const fieldset = $('fieldset', themeBox);
        if (fieldset) fieldset.hidden = !on;
        // disabled inputs are not submitted, so a hidden picker can't leak a Theme property
        $$('fieldset input, fieldset select', themeBox).forEach((el) => { el.disabled = !on; el.required = on; });
        const note = $('[data-theme-scratch]', themeBox);
        if (note) note.hidden = on;

        // tiles (radios), or the older dropdown
        const radios = $$('[data-theme-radio]', themeBox);
        const sel = $('[data-theme-select]', themeBox);
        const picked = radios.length ? (radios.find((r) => r.checked) || null) : sel;
        const value = picked ? picked.value : '';
        const wantTown = ((picked && picked.dataset.hometownValue) || (sel && sel.dataset.hometownValue) || '').toLowerCase();

        const town = $('[data-hometown-field]', themeBox);
        if (town) {
          const wantsTown = on && value !== '' && value.toLowerCase() === wantTown;
          town.hidden = !wantsTown;
          const input = $('input', town);
          if (input) { input.required = wantsTown; input.disabled = !wantsTown; }
        }
        const prev = $('[data-theme-preview]', themeBox);
        const img = prev && $('img', prev);
        const src = picked && picked.dataset ? picked.dataset.img : '';
        if (prev && img) {
          if (on && src) { img.src = src; img.alt = value; prev.hidden = false; }
          else { prev.hidden = true; }
        }
      }

      // delivery promise: days depend on the edition, and on rush
      const dcfg = this.cfg.delivery || {};
      const editionNow = this.cfg.editionIndex > -1 ? String(opts[this.cfg.editionIndex] || '') : '';
      const isAlt = !!dcfg.altEdition && editionNow.toLowerCase().includes(String(dcfg.altEdition).toLowerCase());
      const stdDays = Number(isAlt ? dcfg.altStandard : dcfg.standard) || this.cfg.standardDays;
      const rushDays = Number(isAlt ? dcfg.altRush : dcfg.rush) || this.cfg.rushDays;
      const days = isRush ? rushDays : stdDays;
      const by = addDays(days);
      $$('[data-eta]', this).forEach((el) => { el.textContent = fmtDate(by); });
      $$('[data-eta-days]', this).forEach((el) => { el.textContent = fmtDate(addDays(rushDays)); });

      // the rush line says a different number of days for the slower edition
      const rt = $('[data-rush-title]', this), rx = $('[data-rush-text]', this);
      if (rt) { const t = isAlt ? dcfg.altRushTitle : dcfg.rushTitle; if (t) rt.textContent = t; }
      if (rx) { const t = isAlt ? (dcfg.altRushText || dcfg.rushText) : dcfg.rushText; if (t) rx.textContent = t; }

      // the calendar can't offer a date we cannot make: earliest is today + the soonest we can deliver
      const dateInput = $('[data-big-day]', this);
      if (dateInput) {
        const soonest = addDays(Math.min(stdDays, rushDays));
        dateInput.min = iso(soonest);
      }

      const bigDay = dateInput?.value;
      const status = $('[data-date-status]', this);
      if (status) {
        const ok = $('[data-status-ok]', status), late = $('[data-status-late]', status), early = $('[data-status-early]', status);
        [ok, late, early].forEach((x) => { if (x) x.hidden = true; });
        if (!bigDay) { ok.hidden = false; }
        else {
          const d = new Date(`${bigDay}T12:00:00`);
          if (d >= by) ok.hidden = false;
          else if (!isRush && d >= addDays(rushDays) && this.rush) late.hidden = false;
          else early.hidden = false;
        }
      }

      // keep the URL shareable
      const url = new URL(location.href); url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }
  }
  customElements.define('product-builder', ProductBuilder);

  /* product gallery thumbs */
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      $$('[data-thumb]', this).forEach((b) => b.addEventListener('click', () => {
        const i = Number(b.dataset.thumb);
        $$('.gallery__slide', this).forEach((s, j) => s.classList.toggle('is-active', i === j));
        $$('[data-thumb]', this).forEach((t, j) => t.setAttribute('aria-pressed', String(i === j)));
      }));
    }
  }
  customElements.define('product-gallery', ProductGallery);

  /* cart quantity steppers */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('input');
    input.value = Math.max(0, Number(input.value || 0) + Number(b.dataset.qtyStep));
  });
})();

/* compare-reel — drag between the real photo and the gameplay clip */
class CompareReel extends HTMLElement {
  connectedCallback() {
    this.range = this.querySelector('.reel__range');
    if (!this.range) return;
    const set = (v) => this.style.setProperty('--rx', v + '%');
    set(this.range.value);
    const touched = () => { this.classList.add('is-touched'); this.classList.remove('is-hinting'); };
    this.range.addEventListener('input', () => { set(this.range.value); touched(); });
    this.range.addEventListener('pointerdown', touched);
    if ('IntersectionObserver' in window) {
      const hint = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && !this.classList.contains('is-touched')) {
            this.classList.add('is-hinting');
            setTimeout(() => this.classList.remove('is-hinting'), 6000);
            hint.disconnect();
          }
        });
      }, { threshold: 0.4 });
      hint.observe(this);
    } else { this.classList.add('is-hinting'); }
    const video = this.querySelector('video');
    if (video) {
      video.muted = true;
      const play = () => { const p = video.play(); if (p && p.catch) p.catch(() => {}); };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          entries.forEach((e) => { if (e.isIntersecting) play(); else video.pause(); });
        }, { threshold: 0.2 }).observe(this);
      } else { play(); }
    }
  }
}
if (!customElements.get('compare-reel')) customElements.define('compare-reel', CompareReel);

/* =====================================================================
   Landing pages
   ===================================================================== */

/* <date-check> — "when's the birthday?"
   Takes a date and answers with the last safe day to order. The day counts and
   every sentence come from the section settings, so nothing is hardcoded here. */
class DateCheck extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-date]');
    this.out = this.querySelector('[data-out]');
    this.cta = this.querySelector('[data-cta]');
    if (!this.input || !this.out) return;

    this.std = Number(this.dataset.standard) || 7;
    this.rush = Number(this.dataset.rush) || 4;

    // can't post a game into the past
    const t = new Date(); t.setHours(12, 0, 0, 0);
    this.input.min = DateCheck.iso(t);

    this.querySelector('[data-go]')?.addEventListener('click', () => this.run());
    this.input.addEventListener('change', () => this.run());
  }

  static iso(d) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }

  /* **bold** in the settings becomes <strong>; everything else is escaped,
     because these strings are merchant copy, not markup. */
  static render(text, vars) {
    const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    let out = esc(text || '');
    for (const [k, v] of Object.entries(vars)) out = out.split(`[${k}]`).join(esc(v));
    return out.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  }

  run() {
    if (!this.input.value) return;

    const day = new Date(`${this.input.value}T12:00:00`);
    if (isNaN(day)) return;
    const now = new Date(); now.setHours(12, 0, 0, 0);
    const days = Math.round((day - now) / 86400000);

    const fmt = (d) => d.toLocaleDateString(document.documentElement.lang || 'en', { month: 'short', day: 'numeric' });
    const last = new Date(day); last.setDate(last.getDate() - this.std);

    let msg, tone;
    if (days < 0) { msg = this.dataset.msgPast; tone = 'idle'; }
    else if (days >= this.std) { msg = this.dataset.msgPlenty; tone = 'ok'; }
    else if (days >= this.rush) { msg = this.dataset.msgRush; tone = 'rush'; }
    else { msg = this.dataset.msgTight; tone = 'late'; }

    this.out.className = `lp-check__out lp-check__out--${tone}`;
    this.out.innerHTML = DateCheck.render(msg, { date: fmt(last), days, standard: this.std, rush: this.rush });
    if (this.cta) this.cta.hidden = days < 0;
  }
}
if (!customElements.get('date-check')) customElements.define('date-check', DateCheck);

/* Landing pages link through with ?occasion=birthday&world=winter — pick those
   up on the product page so the customer arrives with their choices made. */
(() => {
  const preselect = () => {
    const builder = document.querySelector('product-builder');
    if (!builder) return;
    const p = new URLSearchParams(location.search);
    const want = (s) => String(s || '').trim().toLowerCase();
    const fire = (el) => el.dispatchEvent(new Event('change', { bubbles: true }));

    const occasion = p.get('occasion');
    if (occasion) {
      const sel = builder.querySelector('[data-occasion], select[name="properties[Occasion]"]');
      if (sel) {
        const hit = [...sel.options].find((o) => want(o.value || o.textContent) === want(occasion));
        if (hit) { sel.value = hit.value || hit.textContent; fire(sel); }
      }
    }

    const world = p.get('world');
    if (world) {
      const radios = [...builder.querySelectorAll('[data-theme-radio]')];
      // exact match first, then a looser one so ?world=winter finds "Winter"
      const hit = radios.find((r) => want(r.value) === want(world))
               || radios.find((r) => want(r.value).includes(want(world)));
      // a disabled radio means the picker is hidden for this edition; leave it alone
      if (hit && !hit.disabled) { hit.checked = true; fire(hit); }
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preselect);
  else preselect();
})();


/* ===== Game card hover clips =============================================
   Appended block. Desktop: play while the pointer is over a card.
   Touch: play whichever card is most in view, one at a time.
   The still image stays put until the clip is genuinely rolling, so a card
   never flashes black on a slow connection or a browser that cannot play it. */
(() => {
  const CARD = '[data-game-clip]';
  const reduce   = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePtr  = window.matchMedia('(hover: hover) and (pointer: fine)');
  const saveData = !!(navigator.connection && navigator.connection.saveData);

  let observer = null;
  let bound = [];

  const clipOf = card => card.querySelector('.game-card__clip');

  function attachSources(v){
    if (v.dataset.loaded) return;
    v.dataset.loaded = '1';
    let list = [];
    try { list = JSON.parse(v.dataset.sources || '[]'); } catch (e) { list = []; }
    list.forEach(s => {
      if (!s || !s.src) return;
      const el = document.createElement('source');
      el.src = s.src;
      if (s.type) el.type = s.type;
      v.appendChild(el);
    });
    v.load();
  }

  function start(card){
    if (reduce.matches || saveData) return;
    const v = clipOf(card);
    if (!v) return;

    attachSources(v);

    if (!v.dataset.wired){
      v.dataset.wired = '1';
      v.addEventListener('playing', () => {
        if (card.dataset.want === '1') card.classList.add('is-playing');
      });
    }

    card.dataset.want = '1';
    try {
      const p = v.play();
      if (p && p.catch) p.catch(() => {});   // a refused autoplay just leaves the still image
    } catch (e) { /* same */ }
  }

  function stop(card){
    card.dataset.want = '0';
    card.classList.remove('is-playing');
    const v = clipOf(card);
    if (!v) return;
    v.pause();
    try { v.currentTime = 0; } catch (e) {}
  }

  function teardown(){
    if (observer){ observer.disconnect(); observer = null; }
    bound.forEach(({el, type, fn}) => el.removeEventListener(type, fn));
    bound = [];
    document.querySelectorAll(CARD).forEach(stop);
  }

  function on(el, type, fn){ el.addEventListener(type, fn); bound.push({el, type, fn}); }

  function setup(mode){
    teardown();
    const cards = Array.from(document.querySelectorAll(CARD));
    if (!cards.length || reduce.matches || saveData) return;

    const wantHover = mode === 'hover' || (mode === 'auto' && finePtr.matches);

    if (wantHover){
      cards.forEach(card => {
        on(card, 'pointerenter', () => start(card));
        on(card, 'pointerleave', () => stop(card));
        on(card, 'focusin',      () => start(card));
        on(card, 'focusout',     () => stop(card));
      });
      return;
    }

    // Touch: whichever thumbnail is most visible plays, the rest stay paused.
    const ratios = new Map();
    const cardOf = new Map();
    const thumbs = [];
    cards.forEach(card => {
      if (card.dataset.clipMobile === 'off') return;
      const thumb = card.querySelector('.game-card__thumb');
      if (!thumb) return;
      cardOf.set(thumb, card);
      thumbs.push(thumb);
    });
    if (!thumbs.length) return;

    observer = new IntersectionObserver(entries => {
      entries.forEach(e => ratios.set(e.target, e.isIntersecting ? e.intersectionRatio : 0));
      let best = null, bestRatio = 0;
      ratios.forEach((r, el) => { if (r > bestRatio){ bestRatio = r; best = el; } });
      thumbs.forEach(t => {
        const card = cardOf.get(t);
        if (t === best && bestRatio >= 0.6) start(card); else stop(card);
      });
    }, { threshold: [0, 0.25, 0.5, 0.6, 0.75, 0.9, 1] });

    thumbs.forEach(t => observer.observe(t));
  }

  const auto = () => setup('auto');

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) document.querySelectorAll(CARD).forEach(stop);
  });

  if (finePtr.addEventListener) finePtr.addEventListener('change', auto);
  if (reduce.addEventListener)  reduce.addEventListener('change', auto);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', auto);
  else auto();

  // Shopify re-renders a section in the theme editor without reloading the page.
  document.addEventListener('shopify:section:load', auto);
  document.addEventListener('shopify:section:unload', auto);

  window.MuksunGameClips = { setup, auto };
})();
/* ===== end game card hover clips ======================================== */
